import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { Toast } from "../../services";
import AuthService from "../../config/auth/auth.service";
import { Iconsvg } from '@wk/components-react16';
import { config, errorList } from "../../config/constants";
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { loginRequest } from '../../config/constants/authConfig';
import logoWheellarge from "../../assets/images/wheel-large.svg"

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [hasNavigated, setHasNavigated] = useState(true);

  const handleLogin = (loginType: string) => {
    if (loginType == "popup") {
      instance.loginPopup(loginRequest).then((res: any) => {
        submit(res.idToken);
        setHasNavigated(false);
      }).catch((err: any) => {
        Toast("Error, please try again", "error");
      });
    } else if (loginType == "redirect") {
      instance.loginRedirect(loginRequest).then((res: any) => {
      });
    }
  }

  const handleError = (status: number, message?: string) => {
    if (
      status === 504 ||
      status === 503 ||
      status === 502 ||
      status === 500 ||
      status === 404 ||
      status === 403 ||
      status === 401 ||
      status === 400
    ) {
      Toast(message || errorList.get(status), "error")
    }
  }

  const submit = async (idToken: any) => {
    AuthService.login(idToken).then(
      (res: any) => {
        if (res.status === 200 || res.status === 204) {
          if (res.projects) {
            const navItems = AuthService.privilegeItems();
            navigate(navItems[0]?.href);
          } else {
            Toast("No associated projects. Contact your administrator.", "error");
            //AuthService.logout(navigate, instance);
          }
        } else {
          handleError(res.status, res.message);
        }
      },
      (err: any) => {
        handleError(err.response?.status || 503, err.response?.statusText)
      },
    )
  }

  // useEffect(() => {
    // if (isAuthenticated && hasNavigated) {
    //   if (accounts.length > 0 && accounts[0].username && accounts[0].username != '' && accounts[0].username != null){
    //     submit(accounts[0].username);
    //   }
    // }
  // }, [accounts, isAuthenticated, hasNavigated]);

  return (
    <div className="light-mode">
      <div className="pattern"></div>
      <div className="mirror">
        <div className='leftShade' style={{marginRight: '120px'}}>Content</div>
        <div className="rightShade" style={{ marginLeft: '100px' }}>Rocket</div>
      </div>
      <div className="login-form login-card">
        <div className="login-logo">
          <img src={logoWheellarge} alt="Wolters Kluwer" />
        </div>
        <div className="login-c mb-40">
          <h4 className="heading">{" "}</h4>
          <div className="pt-30">Sign in with SSO</div>
          <button className="btnn" onClick={() => handleLogin("popup")}>SSO LOGIN <Iconsvg name="arrow-right" color="#ffffff"></Iconsvg>
          </button>
        </div>
        <div className="copyright">
          © {config.copyright} Wolters Kluwer. All rights reserved.
        </div>
      </div>
    </div>
  )
}

export default Login
